<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PREGLED IZDATNICA</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <dx-button
          class="btn_trazi"
          [disabled]="disableGumb"
          stylingMode="contained"
          text="Prikaži"
          type="success"
          [width]="120"
          (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>
    <!-- "problem" pravilo to što export button bude iza Pretraži... (zbog direction: rtl;) pa je dodana klasa pregledIzdatnica u style.css -->
                          <!-- dnevniPlan -->
    <div class="customTable pregledIzdatnica">
      <dx-data-grid
        #datagrid
        id="tablicaIzdatnica"
        [dataSource]="izdatnice"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="pz_id"
        [showColumnLines]="true"
        [showBorders]="false"
        [columnAutoWidth]="true"
        [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onRowClick)="onRowClick($event)">

        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Pregled izdatnica</h2>
            <p class="mt-0">Kliknite na izdatnicu za prikaz detalja</p>
          </div>
          <div class="d-inline ml-15">
            <dx-button [disabled]="pravaZaTrenutniPogled != 2"
              icon="plus"
              hint="Dodaj izdatnicu"
              stylingMode="outlined"
              type="success"
              (click)="dodajIzdatnicuPopup()">
            </dx-button>
            <dx-popup
              [width]="600"
              [height]="'auto'"
              [showTitle]="true"
              title="{{ naslov }}"
              [dragEnabled]="true"
              [closeOnOutsideClick]="false"
              [position]="{ my: 'top', at: 'top', offset: '0 104' }"
              [(visible)]="dodajIzdatnicuPopupVisible"
              (onHiding)="popupHidden()">
              <div>
                <!-- zatrazeno na sastanku 01.12.2023 da samo plan odaberu -->
                <!--
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-select-box
                      [dataSource]="tipoviSkladista"
                      displayExpr="vp_naziv"
                      valueExpr="idvrstaposlovnice"
                      [(value)]="odabranTipSkladista"
                      placeholder="Odaberi tip skladište"
                      [searchEnabled]="true"
                      (onValueChanged)="odaberiTipSkladista($event)">
                    </dx-select-box>
                  </div>
                </div>
                -->
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-select-box
                      [dataSource]="sviPlanovi"
                      displayExpr="plandatumsmjenalinija"
                      [(value)]="odabraniPlan"
                      placeholder="Odaberi plan"
                      [searchEnabled]="true"
                      [searchExpr]="['idplanproizvodnje', 'li_naziv']"
                      (onValueChanged)="odaberiPlan($event)">
                    </dx-select-box>
                  </div>
                </div>
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-select-box
                      [dataSource]="svaSkladista"
                      displayExpr="sifrainaziv"
                      [(value)]="odabranoSkladiste"
                      placeholder="Odaberi skladište"
                      [searchEnabled]="true"
                      [searchExpr]="['po_sifra', 'po_naziv']"
                      (onValueChanged)="odaberiSkladiste($event)">
                    </dx-select-box>
                  </div>
                </div>
                <div class="dx-field float-right">
                  <dx-button
                    [disabled]="odabraniPlan == null || odabranoSkladiste == null"
                    stylingMode="contained"
                    text="Dodajj"
                    type="success"
                    [width]="120"
                    (onClick)="dodaj_izdatnicu()">
                  </dx-button>
                </div>
              </div>
            </dx-popup>
          </div>
        </div>

        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true" width="350"></dxo-header-filter>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'">
        </dxo-scrolling>
          
        <dxo-export [enabled]="dozvoli_export" fileName="pregled_izdatnica"></dxo-export>
        
        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži...">
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true">
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxi-column
          dataField="pz_broj"
          caption="Broj izdatnice"
          [width]="140"
          alignment="right"
          [calculateSortValue]="calculateSortValue">
        </dxi-column>
        <dxi-column
          dataField="pz_id"
          caption="Broj zahtjeva"
          [width]="140"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="pz_datum"
          dataType="date"
          caption="Datum"
          [width]="160"
          alignment="left">
        </dxi-column>
        <dxi-column
          dataField="pz_danisat"
          dataType="datetime"
          caption="Kreirano"
          [width]="160"
          alignment="left">
        </dxi-column>
        <dxi-column
          dataField="po_sifra"
          caption="Šifra skladišta"
          [width]="120">
        </dxi-column>
        <dxi-column
          dataField="po_naziv"
          caption="Skladište"
          [minWidth]="250">
        </dxi-column>
        <dxi-column
          dataField="nl_broj"
          caption="Radni nalog"
          [width]="100">
        </dxi-column>
        <dxi-column
          dataField="planproizvodnje_idplanproizvodnje"
          caption="Plan"
          [width]="100">
        </dxi-column>
        <dxi-column
          dataField="smjena_idsmjena"
          caption="Smjena"
          [width]="120"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="li_naziv"
          caption="Linija"
          [width]="200">
        </dxi-column>
        <dxi-column
          dataField="pz_iznos"
          caption="Iznos"
          format="#,##0.## €"
          alignment="right"
          [width]="140">
        </dxi-column>
        <dxi-column
          dataField="pz_porez"
          caption="Porez"
          format="#,##0.## €"
          alignment="right"
          [width]="130">
        </dxi-column>
        <dxi-column
          dataField="pz_status"
          caption="Status"
          [width]="120"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="name"
          caption="Izdala osoba"
          [minWidth]="150">
        </dxi-column>
        <dxi-column 
          dataField="log_sinkronizirano" 
          caption="Sinkronizirano"
          alignment="center">
          <dxo-lookup
            [dataSource]="statusArray"
            displayExpr="status_naziv"
            valueExpr="status_vrijednost">
          </dxo-lookup>
        </dxi-column>
        <dxi-column 
          dataField="log_vrijeme_sinkronizacije" 
          dataType="datetime"
          caption="Vrijeme sink."
          [width]="200"
          alignment="left">
        </dxi-column>
        <dxi-column caption="PDF" cellTemplate="pdf" [allowExporting]="false" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'pdf'">
            <dx-button hint="PDF" icon="pdffile" (onClick)="izdatnicaPDF(data)"></dx-button>
          </div>
        </dxi-column>
        <dxi-column caption="Storniraj" cellTemplate="cellStorno" [minWidth]="100" alignment="center" [allowExporting]="false" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'cellStorno'">
            <dx-button [disabled]="data.data.pz_status != 'Z'" hint="Storniraj" icon="close" (onClick)="stornirajPopup(data)"></dx-button>
          </div>
        </dxi-column>
        <dxi-column cellTemplate="uredjivanje" [width]="110" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'uredjivanje'">
            <dx-button [disabled]="data.data.pz_status == 'Z'" 
              icon="check"
              hint="Završi" 
              (onClick)="zavrsiPopup(data)">
            </dx-button>
            <dx-button *ngIf="data.data.pz_status == 'I'"
              icon="trash"
              hint="Obriši"
              (onClick)="obrisiIzdatnicu(data)">
            </dx-button>
          </div>
        </dxi-column> 
        <dxo-master-detail
          [enabled]="false"
          template="detail">
        </dxo-master-detail>
        <div *dxTemplate="let data of 'detail'">
          <!-- <p *ngIf="!stavke">Dohvaćanje stavki...</p>
          <p *ngIf="stavke.length === 0">Izdatnica nema stavki!</p>
          <div *ngIf="stavke.length > 0"> -->
          <div *ngIf="isLoading" class="content-block">Učitavanje tablice...</div>
          <div *ngIf="!isLoading">
            <div class="izdatnicaStavke">
              <!--problem što se pri dnu tablice klikom na red ne prikaže cijela tree lista (mora se dva puta kliknuti onda bude dobro) -->
              <!-- dx-tree-list -->
              <dx-data-grid 
                [dataSource]="stavke"
                [wordWrapEnabled]="true"
                keyExpr="ps_id"
                [showBorders]="true"
                (onInitNewRow)="onInitNewRow($event)"
                (onEditingStart)="onEditingStart($event)"
                (onRowInserted)="dodajStavku($event)"
                (onRowUpdated)="urediStavku($event)"
                (onRowRemoved)="obrisiStavku($event)">
                
              <dxo-editing mode="popup" 
                [allowUpdating]="dozvoliUredivanje"
                [allowAdding]="dozvoliUredivanje"
                [allowDeleting]="dozvoliUredivanje">

                <dxo-popup                        
                  [onShowing]="onShowing"
                  title= ""
                  [showTitle]="true"
                  [width]="500"
                  [height]="'auto'">
                </dxo-popup> 

                <dxo-form>
                  <dxi-item itemType="group" [colCount]="1" [colSpan]="2">
                    <dxi-item dataField="artikl_ar_id"></dxi-item>
                    <dxi-item dataField="ps_izlaz"  editorType="dxNumberBox"></dxi-item>
                    <dxi-item dataField="ar_lot"></dxi-item>
                  </dxi-item>
                </dxo-form>

              </dxo-editing>
              
                <dxi-column
                  dataField="ar_sifra"
                  caption="Šifra"
                  [width]="120"
                  [allowEditing]="false">
                </dxi-column>
                <!-- u tablici prikazujem jedno (ar_naziv) a u formi za dodavanje/uredivanje drugo (artikl_ar_id) -->
                <dxi-column
                  dataField="ar_naziv"
                  caption="Proizvod"
                  [width]="300"
                  [allowEditing]="false">
                </dxi-column>
                <dxi-column
                  dataField="artikl_ar_id"
                  caption="Proizvod"
                  [width]="300"
                  [allowEditing]="true"
                  [visible]="false" [formItem]="{ visible: true }"
                  [editorOptions]="{ onItemClick: odabranArtikl, showClearButton: true, searchExpr: 'artiklsifranaziv' }">
                  <dxo-lookup
                    [dataSource]="sviArtikli_poslovnica"
                    valueExpr="ar_id"
                    displayExpr="artiklsifranaziv">
                  </dxo-lookup>
                </dxi-column>
                <dxi-column
                  dataField="ps_izlaz"
                  caption="Količina"
                  [width]="100">
                </dxi-column>
                <dxi-column
                  dataField="jedinicamjere_JM_SIFRA"
                  caption="Jed.mj."
                  [width]="80"
                  [allowEditing]="false">
                </dxi-column>
                <!-- u tablici prikazujem jedno a u formi za dodavanje/uredivanje drugo -->
                <!-- zato sto sviLotovi_artikla ovise tj. dohvacaju se i pune kad odaberemo artikl -->
                <dxi-column
                  dataField="ar_lot"
                  caption="LOT"
                  [width]="300"
                  [allowEditing]="true"
                  [visible]="false"
                  [formItem]="{ visible: true }"
                  [editorOptions]="{ value: artikl_lot, onItemClick: odabranLot }">
                  <dxo-lookup
                    [dataSource]="sviLotovi_artikla"
                    valueExpr="ar_lot"
                    displayExpr="ar_datum_ar_vazido_ar_lot_ar_lotstanje_spojeno">
                  </dxo-lookup>
                </dxi-column>
                <dxi-column
                  dataField="ar_lot"
                  caption="LOT"
                  [width]="100"
                  [formItem]="{ visible: false }">
                </dxi-column>
                <dxi-column
                  dataField="ps_izlazc"
                  caption="Cijena"
                  [width]="100"
                  [allowEditing]="false">
                </dxi-column>
              </dx-data-grid>
            </div>
          </div>
        </div>
        <dxo-summary>
          <dxi-total-item 
            column="li_naziv" 
            summaryType="sum" 
            alignment="left" 
            summaryType="sum" 
            displayFormat="Ukupno:">
          </dxi-total-item>
          <dxi-total-item
            column="pz_iznos"
            summaryType="sum"
            alignment="right"
            summaryType="sum"
            displayFormat="{0} €"
            [valueFormat]="{ type: 'fixedPoint', precision: 2 }">
          </dxi-total-item>
          <dxi-total-item
            column="pz_porez"
            summaryType="sum"
            alignment="right"
            summaryType="sum"
            displayFormat="{0} €"
            [valueFormat]="{ type: 'fixedPoint', precision: 2 }">
          </dxi-total-item>
        </dxo-summary>
      </dx-data-grid>
    </div>
  </div>

  <dx-popup
    [width]="400"
    [height]="'auto'"
    [showTitle]="true"
    title="Storniraj izdatnicu"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 300' }"
    [(visible)]="stornirajPopupVisible">
    <p>Jeste li sigurni da želite stornirati izdatnicu?</p>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="DA"
      (onClick)="storniraj()">
    </dx-button>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="danger"
      text="NE"
      (onClick)="stornirajPopupVisible = false">
    </dx-button>
  </dx-popup>

  <dx-popup
    [width]="400"
    [height]="'auto'"
    [showTitle]="true"
    title="Završi izdatnicu"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [position]="{ my: 'top', at: 'center top', of: '', offset: '0 300' }"
    [(visible)]="zavrsiPopupVisible">
    <p>Jeste li sigurni da želite završiti izdatnicu?</p>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="success"
      text="DA"
      (onClick)="zavrsiIzdatnicu()">
    </dx-button>
    <dx-button
      class="dodajButton"
      stylingMode="outlined"
      type="danger"
      text="NE"
      (onClick)="zavrsiPopupVisible = false">
    </dx-button>
  </dx-popup>

</div>
